import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::SaasSharedUiShim @componentName=\"UpsellPaywallCard\" @feature={{this.feature}} @onActivate={{this.onActivate}} @shimTag={{this.shimTag}}>{{yield}}</Saas::SaasSharedUiShim>", {
  moduleName: "@dashboard/shared-ui/components/saas/upsell-paywall-card.hbs"
});